import angular from 'angular';
import uiRouter from 'angular-ui-router';
import toMillisDirective from './toMillis.directive';


import OrderAndPickDetailsComponent from './orderAndPick.component';

const orderAndPickDetailsModule = angular.module('tinaba.components.services.orderAndPick', [
  uiRouter
])
.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('services.orderAndPick', {
    url: '/orderAndPick',
    template: '<order-and-pick-details></order-and-pick-details>'
  });
})

.component('orderAndPickDetails', OrderAndPickDetailsComponent)
  .directive('toMillis', toMillisDirective);

export default orderAndPickDetailsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPick/orderAndPick.js
 **/